import React, { useEffect, useState } from "react";
import Loading from "../../components/Loading";

export default function RedirectTo() {
	const queryParam = new URLSearchParams(window.location.search);
	const [platform, setPlatform] = useState("");

	useEffect(() => {
		if (queryParam.toString()) {
			redirect();
		}
		// eslint-disable-next-line
	}, []);

	function openApp(urlScheme, fallbackUrl) {
		let timeout;

		const now = Date.now();

		if (navigator.userAgent.match(/iPhone|iPod|iPad|Android/i)) {
			window.location.href = urlScheme;
		}

		timeout = setTimeout(function () {
			if (Date.now() - now < 1500) {
				window.location.href = fallbackUrl;
				clearTimeout(timeout);
			}
		}, 1000);
	}

	function redirect() {
		const url = queryParam.toString().substring(2);
		let decodeURL = decodeURIComponent(url);
		const platform = getParameterUrl(decodeURL, "platform") ?? "trademap";
		const idInfluencer = getParameterUrl(decodeURL, "id_influencer");
		const action = getParameterUrl(decodeURL, "action");

		if (action && action.toUpperCase() === "OPEN_INFLUENCE_AND_OPEN_URL") {
			const urlContainsParameters = Boolean(new URL(getParameterUrl(decodeURL, "url")).search)
				? "&"
				: "?";

			decodeURL = replaceUrlParam(
				decodeURL,
				`${getParameterUrl(
					decodeURL,
					"url"
				)}${urlContainsParameters}id_influencer=${idInfluencer}`
			);
		}

		setPlatform(platform);
		openApp(`${platform}://${decodeURL.substring(8)}`, decodeURL);
	}

	/**
	 * @param {string} url - current link
	 * @param {string} param - search for this parameter in the URL
	 * @returns {string | undefined}
	 */
	const getParameterUrl = (url, param) => new URLSearchParams(new URL(url).search).getAll(param).at();

	/**
	 * @param {string} url - current link
	 * @param {string} newValue - new value for the parameter
	 * @returns {string}
	 */
	const replaceUrlParam = (url, newValue) => {
		const currentUrl = new URL(url);

		const params = new URLSearchParams(currentUrl.search);

		params.forEach((_, key) => {
			if (["url", "adj_fallback", "adj_redirect_macos"].includes(key)) {
				params.set(key, newValue);
			}
		});

		currentUrl.search = params.toString();

		return currentUrl.toString();
	};

	return (
		<Loading
			newLoading={platform === "trademap"}
			isRocketTrader={platform === "rockettrader"}
			color={platform == "minhaseconomias" ? "#0fd15d" : null}
		/>
	);
}
